import React from "react";
import "./App.css";
import CustomerContextWrapper from "./contexts/CustomerContext";
import Routes from "./Routes";

const App: React.FC = () => {
  return (
    <CustomerContextWrapper>
      <Routes />
    </CustomerContextWrapper>
  );
};

export default App;
